import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ApiGridInfo, GridInfo, IActualSystemMenuPermission } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ExportService } from 'src/app/tabms/services/global/export.service';
import { BaseViewComponent } from '../base-view/base-view.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ConfirmationComponent } from '../../global/confirmation/confirmation.component';
import { BaseInfoComponent } from '../base-info/base-info.component';
import { BaseNotesComponent } from '../base-notes/base-notes.component';
import { BaseAttachComponent } from '../base-attach/base-attach.component';
import { BaseUploadTemplateComponent } from '../base-upload-template/base-upload-template.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommandService } from 'src/app/tabms/services/global/command.service';
import { TranslateService } from '@ngx-translate/core';
import { DELETESUCCESS, OPERERROR } from 'src/app/tabms/tab-consts';
import { BaseSendSMSComponent } from '../base-send-sms/base-send-sms.component';
import { BaseSendWahtsupComponent } from '../base-send-wahtsup/base-send-wahtsup.component';
import { BaseSendMailComponent } from '../base-send-mail/base-send-mail.component';
import { catchError, map, startWith, switchMap, of as observableOf, Subject, takeUntil, tap, of, forkJoin } from 'rxjs';
import { size } from 'lodash';
import { environment } from 'src/environments/environment';
import { UserMenuService } from 'src/app/tabms/services/user/user-menu.service';
import { PermissionsListService } from 'src/app/tabms/services/global/permissions-list.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { TabSystemMenuService } from 'src/app/tabms/services/menu/tab-system-menu.service';
import { SqlSearchService } from 'src/app/tabms/services/sql-search/sql-search.service';

@Component({
  selector: 'app-base-grid',
  templateUrl: './base-grid.component.html',
  styleUrl: './base-grid.component.scss'
})
export class BaseGridComponent<T> implements OnInit {
  //#region Input
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }

  @Input() set fieldsConfigService(_fieldsConfigService) {
    if (!_fieldsConfigService) return;
    this.fieldsConfigServiceInstance = _fieldsConfigService;
  }

  @Input() set formComponent(_formComponent) {
    if (!_formComponent) return;
    this.formComponentInstance = _formComponent;
  }
  @Input() canEdit :boolean=true;
  @Input() canDelete:boolean =true;

  @Input() disableActionsFieldName?:string ;
  @Input() disableActionsValue?:any ;
  @Input() disableDeleteFieldName?: string;
  @Input() disableDeleteValue?: any;
  //#endregion
  // @ViewChild(MatTable) table;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // @ViewChild('paginator') paginator: MatPaginator;
  // @ViewChild('sort') sort: MatSort;
  pageSizes = [5, 10, 25];
  //#region public props
  serviceInstance; //: IBaseService<T>;
  fieldsConfigServiceInstance;
  // gridInfoData: ApiGridInfo[];
  gridInfoData: ApiGridInfo[] = [];
  dataSource: MatTableDataSource<T>;
  displayedColumns;
  printListFields;
  selection = new SelectionModel<any>(true, []);
  searchValue: string;
  selectedOption: string;
  gridData: any[];
  totalcount: number;
  systemMenuId;
  gridMenu;
  filterSqlQuery;
  criteriaParams;
  type; // type of get data if filter or criteria or without filter
  // baseImageUrl = environment.filesUrl;
  // baseImageUrl = 'https://storage.googleapis.com/tabms_files/attachments/';
  formComponentInstance;
  //#endregion
  pageName: string;
  permissions: IActualSystemMenuPermission;
  pageNameTitle: string;
  currentLang: string;
  menuKey: string;
  pageParameter: string;
  dataWithAllRowData: any[] = []; // to hold all data when export with all rows
  branchId: string;
  pageIndex: number = 0;
  pageSize: number = 100;

  private destroy$: Subject<void> = new Subject<void>();

  //#region constructor
  constructor(
    private baseService: BaseService,
    private exportService: ExportService,
    private changeDetectorRefs: ChangeDetectorRef,
    public dialog: MatDialog,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private commandService: CommandService,
    private translate: TranslateService,
    private userMenuService: UserMenuService,
    private permissionListService: PermissionsListService,
    private sessionService: SessionWrapperService,
    private themeLayout: ThemeLayoutService,
    private tabSystemMenuService: TabSystemMenuService,
    private sqlSearchService: SqlSearchService
  ) {
    this.dataSource = new MatTableDataSource<T>(this.gridData);
    this.currentLang = this.baseService.getCurrentLanguage();
    this.themeLayout.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir == RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
        this.getPageName(this.systemMenuId);
      }
    });

    this.sessionService.currentDefaultBranchSubject$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (branch) => {
        this.branchId = branch?.id;
      }
    })
  }
  //#endregion

  //#region lifecycle hooks
  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id'];
        this.getPageName(this.systemMenuId);
        this.getMenuKey(this.systemMenuId);
      }
    });

    this.permissionListService
      .getPagePermissions()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.permissions = res;
        }
      });

    this.baseService.refreshTable.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
      this.type = null;
      this.refreshTable();
    });

    this.baseService.applyCriteria.pipe(takeUntil(this.destroy$)).subscribe((value: Object) => {
      // debugger
      this.applyCriteria(value);
    });

    this.baseService.applyFilter.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
      this.applyFilter(value);
    });

    this.fieldsConfigServiceInstance.printColumnsSubject.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.printListFields = value;
    });

    this.baseService.searchValueChange.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
      this.searchValue = value;
      // this.applySearch();
    });

    this.baseService.exportOptionsChange.pipe(takeUntil(this.destroy$)).subscribe((value: string) => {
      this.selectedOption = value;
      this.exportData();
    });

    this.baseService.pageToolsDynamicMenuChange.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.execStoredProcedureArr(value);
    });

    this.getExtraDynamicMenu();
  }

  ngAfterViewInit() {
    // Setup sorting only - pagination is handled server-side
    this.dataSource.sort = this.sort;

    // Custom sort data accessor to handle nested _entitydto structure
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string) => {
      // Handle special columns that don't use _entitydto
      if (sortHeaderId === 'select' || sortHeaderId === 'action') {
        return '';
      }

      // Get value from _entitydto or direct property
      const value = data._entitydto ? data._entitydto[sortHeaderId] : data[sortHeaderId];

      // Handle different data types for proper sorting
      if (typeof value === 'string') {
        return value.toLowerCase();
      }
      if (typeof value === 'boolean') {
        return value ? 1 : 0;
      }
      if (value === null || value === undefined) {
        return '';
      }

      return value;
    };

    // Disable client-side pagination to maintain server-side pagination
    this.dataSource.paginator = null;
  }

  setDisplayedColumns(): void {
    this.serviceInstance.gridList(this.menuKey, this.pageParameter).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {

        // debugger
        if (!res || res?.result?.headers?.length == 0) return

        this.gridInfoData = res?.result?.headers;

        // Create unique column names by replacing dots with underscores
        // This preserves the full path to avoid duplicates (e.g., sidearaname vs parentside.sidearaname)
        this.gridInfoData = this.gridInfoData.map(item => ({
          ...item,
          fieldname: item.fieldname.replace(/\./g, '_'),
          displayaraname: item.langvalue?.find(x => x.culuturename === 'ar-EG')?.culuturevalue || item.displayaraname || item.fieldname,
          displaylatname: item.langvalue?.find(x => x.culuturename === 'en')?.culuturevalue || item.displaylatname || item.fieldname
        }));

        this.gridInfoData?.unshift({
          fieldname: 'select',
          displayaraname: 'select',
          displaylatname: 'select',
          fieldtype: "checkbox"
        })
        this.gridInfoData?.push({
          fieldname: 'action',
          displayaraname: 'action',
          displaylatname: 'action',
          fieldtype: "action"
        })
        this.displayedColumns = this.gridInfoData?.map((c) => c.fieldname);
        this.refreshTable();
      }
    })
  }

  getTableData$(pageIndex: Number, pageSize: Number) {
    // let params = {branchid: this.branchId}
    if (this.type == 'filter') return this.sqlSearchService.GetFilterData(this.systemMenuId, this.filterSqlQuery, pageIndex, pageSize);
    // else if (this.type == 'criteria') return this.serviceInstance.GetalldatabyfilterWithCount(pageIndex, pageSize, this.criteriaParams);
    else if (this.type == 'criteria') return this.serviceInstance.gridList(this.menuKey, this.pageParameter, 1, pageIndex, pageSize, this.criteriaParams);
    // else if (this.menuKey == 'Stores') return this.serviceInstance.gridList(this.menuKey, this.pageParameter, 1, pageIndex, pageSize)
    else return this.serviceInstance.gridList(this.menuKey, this.pageParameter, 1, pageIndex, pageSize);
  }

  refreshTable() {
    forkJoin({
      allRows: this.getAllRowData(this.pageIndex, this.pageSize)
        .pipe(catchError(() => observableOf(null))),
      tableData: this.getTableData$(this.pageIndex, this.pageSize)
        .pipe(catchError(() => observableOf(null)))
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ allRows, tableData }: any) => {
        if (!tableData) return;

        this.gridData = tableData?.result?.items || [];
        this.totalcount = tableData?.result?.totalcount || 0;

        // Transform keys: replace dots with underscores to match column definitions
        this.gridData = this.gridData.map(item => {
          const entity = item._entitydto ?? {};
          const cleanEntity = Object.fromEntries(
            Object.entries(entity).map(([key, value]) => [
              key.replace(/\./g, '_'),
              value
            ])
          );
          return {
            ...item,
            _entitydto: cleanEntity
          };
        });

        this.dataSource.data = this.gridData;
        this.selection.clear();
      });
  }

  onPageChange(event: any): void {
    // custom-pagination emits { page, pageSize, length } with page 1-based
    const page = event?.page != null && event.page >= 1 ? Number(event.page) : 1;
    this.pageIndex = page - 1;
    this.pageSize = event?.pageSize != null && Number(event.pageSize) > 0 ? Number(event.pageSize) : this.pageSize;
    this.refreshTable();
  }

  getAllRowData(pageIndex: Number, pageSize: Number) {
    return this.serviceInstance.GetalldatabyfilterWithCount(pageIndex, pageSize).pipe(
      tap((res: any) => {
        this.dataWithAllRowData = res?.result?.items;
      }),
      catchError((error) => {
        if (error.status === 404) {
          this.dataWithAllRowData = [];
          return of({ result: { items: [] } }); // ✅ ما يوقفش
        }
        // أخطاء تانية: ترجعيها أو تتعاملي معاها
        return of({ result: { items: [] } });
      })
    );
  }
  //#endregion

  //#region page tools
  //#region methods
  applyFilter(value) {
    this.type = 'filter';
    this.filterSqlQuery = value;
    // console.log('this.filterSqlQuery', this.filterSqlQuery);
    this.refreshTable();
  }

  applyCriteria(value) {
    this.type = 'criteria';
    this.criteriaParams = value;
    this.pageIndex = 0; // Reset to first page
    this.refreshTable();
  }

  //table search filter
  // applySearch() {
  //   // Note: Search filtering should be handled server-side for proper pagination
  //   // Client-side filtering is disabled to maintain server-side pagination
  //   if (this.dataSource) {
  //     this.dataSource.filter = this.searchValue ? this.searchValue.trim().toLowerCase() : '';

  //     if (this.dataSource.paginator) {
  //       this.dataSource.paginator.firstPage();
  //     }
  //   }
  // }
  //#endregion

  //#region export
  exportData() {
    //
    let data: any[] = [];
    let selectedOption = this.selectedOption;
    this.selectedOption = '';
    this.baseService.clearPageSelectedOption.next(true);

    const beforeDownloadTemplateWork = this.formComponentInstance?.beforeDownloadTemplateWork ? this.formComponentInstance.beforeDownloadTemplateWork() : null;

    let extraDownloadProperties = beforeDownloadTemplateWork ? beforeDownloadTemplateWork : null

    switch (selectedOption) {
      case 'temp':
        // this.exportService.exportexcel(this.gridData.slice(0, 2), this.printListFields, extraDownloadProperties, this.pageName);
        this.exportService.exportexcel(this.dataWithAllRowData.map((item) => item._entitydto).slice(0, 2), this.printListFields, extraDownloadProperties, this.pageName); // download template with 2 data rows as sample

        // download template with 2 data rows as sample
        return;
        break;
      case 'uploadExcel':
        this.dialog.open(BaseUploadTemplateComponent, {
          width: '800px',
          direction: this.baseService.getDirection(),
          data: { service: this.serviceInstance, displayListFields: this.printListFields, extraDownloadProperties, type: 0 } // 1 for one row and 0 for list
        });
        return;
        break;
      default:
        //
        break;
    }

    if (this.selection.selected.length > 0 && !this.isAllSelected()) {
      this.selection.selected.forEach((selection) => {
        const allData = this.dataWithAllRowData.find((x) => x.id == selection.id);
        // console.log('allData', allData)
        data.push(allData);
      });
      data = data.map((item) => item._entitydto)
    } else if (this.isAllSelected()) {
      data = this.dataWithAllRowData.map((item) => item._entitydto);
    } else if (this.selection.selected.length == 0) {
      this.baseService.showInfoMessage('NoRecordSelected');
      return;
    }

    switch (selectedOption) {
      case 'excel':
        this.exportService.exportexcel(data, this.printListFields, null, this.pageName);
        break;
      case 'csv':
        this.exportService.exportCsv(data, this.printListFields, this.pageName);
        break;
      case 'pdf':
        this.exportService.exportPdf(data, this.printListFields, this.pageName);
        break;
      default:
        //
        break;
    }
  }
  //#endregion
  //#endregion

  //#region grid methods

  //#region checkbox
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource?.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row: any, index): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${index + 1}`;
  }
  //#endregion

  showDetails(id) {
    this.dialog.open(BaseViewComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { service: this.serviceInstance, id: id, fieldsConfigService: this.fieldsConfigServiceInstance }
    });
  }

  detailsEdit(row, id) {
    // debugger
    const lowerEntity = Object.fromEntries(Object.entries(row._entitydto).map(([k, v]) => [k.toLowerCase(), v]));
    if (id === '00000000-0000-0000-0000-000000000000') id = lowerEntity['code']
    this.baseService.createFormDisplay.next({ show: true, id: id });
  }

  deleteRow(row, id, index) {
    const lowerEntity = Object.fromEntries(Object.entries(row._entitydto).map(([k, v]) => [k.toLowerCase(), v]));
    if (id === '00000000-0000-0000-0000-000000000000') id = lowerEntity['code']
    let dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
      direction: this.baseService.getDirection(),
      data: { message: this.translate.instant('DeleteConfirm') }
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((confirm) => {
        if (confirm) {
          this.serviceInstance
            .delete(id, row._entitydto)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
              // (res) => {
              //   if (res) {
              {
                next: () => {
                  this.refreshTable();
                  this.baseService.showSuccessMessage(DELETESUCCESS);
                },

                error: (err) => {
                  this.baseService.showErrorMessage(OPERERROR);
                }
              });
        }
      });
  }

  attachFile(id) {
    this.dialog.open(BaseAttachComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id, menuKey: this.menuKey, pageParameter: this.pageParameter }
    });
  }// open to attach new file

  attachedFiles(id) {
    this.dialog.open(BaseAttachComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id, menuKey: this.menuKey, pageParameter: this.pageParameter }
    });
  } // open attached files

  exportCSV(id) {
    this.exportService.exportCsv(
      this.dataWithAllRowData.map((x) => x._entitydto).filter((x) => x['id'] == id),
      this.printListFields
    );
  }
  exportExcel(id) {
    let data = this.dataWithAllRowData.map((x) => x._entitydto).filter((x) => x['id'] == id);
    this.exportService.exportexcel(data, this.printListFields);
  }
  exportPdf(id) {
    this.exportService.exportPdf(
      this.dataWithAllRowData.map((x) => x._entitydto).filter((x) => x['id'] == id),
      this.printListFields
    );
  }
  showNotes(id) {
    this.dialog.open(BaseNotesComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id, menuKey: this.menuKey, pageParameter: this.pageParameter }
    });
  }
  showInfo(id) {
    this.dialog.open(BaseInfoComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { service: this.serviceInstance, id: id, fieldsConfigService: this.fieldsConfigServiceInstance }
    });
  }
  sendSMS(id) {
    this.dialog.open(BaseSendSMSComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id }
    });
  }

  sendEmail(id) {
    this.dialog.open(BaseSendMailComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id }
    });
  }

  sendWhatup(id) {
    this.dialog.open(BaseSendWahtsupComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: id }
    });
  }

  //#endregion

  //#region dynamic methods
  getExtraDynamicMenu() {
    this.commandService
      .getAll()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.result && res.result.length > 0) {
            this.gridMenu = res.result.filter((x) => x.tabsystemmenuid == this.systemMenuId && x.type == 0);
          }
        },
        error: (err) => {
        }
      });
  }

  //for extra menu from page tools
  execStoredProcedureArr(functionName) {
    let data: T[] = [];
    if (this.selection.selected.length > 0 && !this.isAllSelected()) {
      this.selection.selected.forEach((selection) => {
        data.push(selection);
      });
    } else if (this.isAllSelected()) {
      data = this.gridData;
    } else if (this.selection.selected.length == 0) {
      this.baseService.showInfoMessage('NoRecordSelected');
      return;
    }
    data.forEach((row) => {
      //should accept array of ids for same function
      this.execStoredProcedure(row['id'], functionName);
    });
  }

  //for extra menu from grid tools
  execStoredProcedure(recordId, functionName) {
    //may need system menu id
    this.commandService
      .execStoredProcedure(recordId, functionName)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.baseService.showSuccessMessage('OperationCompletedSuccessfuly');
        },
        (err) => {
          this.baseService.showErrorMessage(OPERERROR);
        }
      );
  }

  //#endregion
  getPageName(id) {
    this.userMenuService
      .get(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.pageName = res.result.menulatname.replaceAll(' ', '');
          this.pageNameTitle = this.currentLang === 'ar' ? res.result.menuaraname : res.result.menulatname;
          this.sessionService.setPageTitle(this.pageNameTitle);
        }
      });
  }

  getMenuKey(id) {
    this.tabSystemMenuService.get(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.menuKey = res.result.menukey;
        this.pageParameter = res.result.pageparameters
        // console.log('this.menuKey', this.menuKey);
        this.sessionService.setMenuKeyAndPageParameter(this.menuKey, this.pageParameter);
        this.setDisplayedColumns();
      }
    });
  }

  enabledByFieldValue(value) {
    const entity = value?._entitydto ?? value;
    return (!this.disableActionsFieldName || entity?.[this.disableActionsFieldName] != this.disableActionsValue);
  }

  deleteEnabledByFieldValue(value) {
    const entity = value?._entitydto ?? value;
    return (!this.disableDeleteFieldName || entity?.[this.disableDeleteFieldName] != this.disableDeleteValue);
  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.fieldsConfigServiceInstance.ngOnDestroy();
  }

  //end region
}
